import { render, staticRenderFns } from "./UserChangeSettingsUser.vue?vue&type=template&id=e10f5f5e&"
import script from "@/scripts/modal/userChangeSettingsUser.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/userChangeSettingsUser.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports